import { renderComponentToImageDataUrl } from "~/lib/dom";

export const useWrappedUp = defineStore("wrapped-up", () => {
  const isOpen = ref(false);

  const cache = new Map<Component, Map<string, string>>();

  async function renderSlide(
    component: Component,
    props: Record<string, any> | null,
  ) {
    let componentCache = cache.get(component);
    if (componentCache) {
      const cachedSlideKey = JSON.stringify(props);
      const cachedSlide = componentCache.get(cachedSlideKey);
      if (cachedSlide) {
        return cachedSlide;
      }
    }

    const slide = await renderComponentToImageDataUrl({
      component,
      props,
      setupContainer: (container) => {
        container.style.overflow = "hidden";
        container.style.fontFamily = "Kontesa";
        container.style.fontWeight = "800";
        container.style.letterSpacing = "-0.02em";
        container.style.lineHeight = "1.2";
        container.style.width = "414px";
        container.style.height = "588px";
        container.style.position = "relative";
      },
      renderOptions: {
        type: "image/jpeg",
        quality: 0.8,
        scale: 2,
      },
    });

    if (!componentCache) {
      componentCache = new Map<string, string>();
      cache.set(component, componentCache);
    }

    componentCache.set(JSON.stringify(props), slide);

    return slide;
  }

  return {
    isOpen,
    renderSlide,
  };
});
